module.exports = __webpack_public_path__ + "static/media/desktopScreenshot07.b1c61222.jpg";